<app-loader *ngIf="isDisabled"></app-loader>
<form name="CompensatoryForm" (ngSubmit)="Validate(CompensatoryForm)" #CompensatoryForm="ngForm" class="pb-2">
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                Compensatory Off Request
            </div>
        </div>
        <div class="card-body">
            <div class="row py-2">
                <div class="col-md-3">
                    <label for="AttendanceDate" class="form-font-label">Attendance
                        Date<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd mmm yyyy" name="AttendanceDate"
                            [(ngModel)]="Compensatory.AttendanceDateObj" ngbDatepicker #AttendanceDate="ngbDatepicker"
                            required (ngModelChange)="Clear()" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="AttendanceDate.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from attendance date!
                    </div>
                </div>
                <div class="col-md-1" style="align-content: end;">
                    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Openpopup()">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Get':'Loading...'}}</button>
                </div>
                <div class="col-md-4">
                    <span>In Time<span class="text-danger">*</span></span>
                    <span style="font-size: 15px" class="text-muted ms-2">
                        {{ Compensatory.InDate | date:'dd MMM yyyy' }}
                    </span>

                    <div class="d-flex align-items-center gap-2">
                        <!-- Date beside -->
                        <ngb-timepicker name="InTime" type="time" [(ngModel)]="Compensatory.InTimeObj" #InTime="ngModel"
                            [ngModelOptions]="{standalone: true}" (change)="timeFormate($event,'InTime')"
                            [ariaKeyShortcuts]="false" class="hidetimepicker" required disabled></ngb-timepicker>
                        <div class="invalid-feedback">
                            Please Enter In Time!
                        </div>
                    </div>

                </div>
                <div class="col-md-4">

                    <span>Out Time<span class="text-danger">*</span></span>
                    <span style="font-size: 15px" class="text-muted ms-2">
                        {{ Compensatory.OutDate | date:'dd MMM yyyy' }}
                    </span>

                    <div class="d-flex align-items-center gap-2">
                        <ngb-timepicker name="OutTime" type="time" [(ngModel)]="Compensatory.OutTimeObj"
                            #OutTime="ngModel" [ngModelOptions]="{standalone: true}"
                            (change)="timeFormate($event,'OutTime')" class="hidetimepicker" required
                            disabled></ngb-timepicker>
                        <div class="invalid-feedback">
                            Please Enter Out Time!
                        </div>



                    </div>


                </div>
            </div>
            <div class="row py-2">
                <div class="col-md-4" style="align-content: center;">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="HalfDay" name="HalfDay"
                            [(ngModel)]="Compensatory.HalfDay" [disabled]="Compensatory.DailyAttendanceInOutID == 0">
                        <label class="form-check-label" for="HalfDay"
                            [ngClass]="{'clicklock':Compensatory.DailyAttendanceInOutID == 0}">Half
                            Day</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="HalfDaySession" class="form-font-label">Half Day Session<span class="text-danger"
                            *ngIf="Compensatory.HalfDay">*</span></label>
                    <select class="form-select" aria-label="HalfDaySession" placeholder="HalfDaySession"
                        title="HalfDaySession" name="HalfDaySession" data-live-search="true"
                        [disabled]="!Compensatory.HalfDay || Compensatory.DailyAttendanceInOutID == 0"
                        [(ngModel)]="Compensatory.HalfDaySession" #HalfDaySession="ngModel" required>
                        <option disabled hidden [value]=null>--Select Half Day Session--</option>
                        @for (HalfDaySession of HalfDaySessions; track HalfDaySession.Value; let i =
                        $index)
                        {
                        <option [value]="HalfDaySession.Value">{{HalfDaySession.Name}}</option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select half day session!
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <label for="Reason" class="form-font-label">Reason</label>
                    <input type="text" class="form-control" placeholder="Ex. Work Load" id="Reason" name="Reason"
                        [(ngModel)]="Compensatory.Reason" #Reason="ngModel"
                        [disabled]="Compensatory.DailyAttendanceInOutID == 0">
                    <!-- <div class="invalid-feedback">
                        Please enter reason!
                    </div> -->
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                    [disabled]="Compensatory.DailyAttendanceInOutID == 0"><i class="bi bi-pass" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>